export default "__VITE_ASSET__oLWNN02P__"